import { registerQuery } from 'data-fetching-client';
import I18n from 'I18n';
import getLangLocale from 'I18n/utils/getLangLocale';
import { getTranslatedGrowthFeatureRpc } from 'feature-store-service-types';
import { rpcClient } from '../client';
export const getFeature = ({
  shortName
}) => {
  const i18nLangLocale =
  // @ts-expect-error dependency missing types
  I18n.loaded && I18n.locale ? getLangLocale() : `${Languages.EN}-us`;
  return rpcClient.call(getTranslatedGrowthFeatureRpc, {
    queryParameters: {
      i18nLangLocale
    },
    pathParameters: {
      shortName
    }
  });
};
export const FEATURE_STORE_FEATURE_QUERY = registerQuery({
  fieldName: 'featureStoreFeature',
  args: ['shortName'],
  fetcher: getFeature
});